import { Pipe, PipeTransform } from '@angular/core';
import { convertDotGroupName } from '../utils';

@Pipe({ name: 'convertDotGroupName', standalone: false })
export class ConvertDotGroupNamePipe implements PipeTransform {
  public transform(groupName: string): string {
    return convertDotGroupName(groupName);
  }
}
